var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.checkTag,{tag:"component",staticClass:"button",attrs:{"href":_vm.href,"to":_vm.to,"value":_vm.value},on:{"click":_vm.buttonClick}},[(_vm.icon)?_c('span',{staticClass:"button__icon"},[_c('i',{class:_vm.icon})]):_vm._e(),(_vm.text)?_c('span',{staticClass:"button__text",domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }